"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require("react-bootstrap");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EnvironmentBanner = (_temp2 = _class = function (_Component) {
  _inherits(EnvironmentBanner, _Component);

  function EnvironmentBanner() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EnvironmentBanner);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EnvironmentBanner.__proto__ || Object.getPrototypeOf(EnvironmentBanner)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: true
    }, _this.handleBannerClick = function () {
      _this.setState({
        show: false
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EnvironmentBanner, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          className = _props.className,
          env = _props.env;
      var show = this.state.show;


      if (env === "production" || !show) {
        return null;
      }

      return _react2.default.createElement(
        _reactBootstrap.Alert,
        {
          bsStyle: "warning",
          className: (0, _classnames2.default)("erg-components-EnvironmentBanner", "erg-no-margin", "text-center", className),
          onClick: this.handleBannerClick },
        env.replace(/^./, env[0].toUpperCase()),
        " Version"
      );
    }
  }]);

  return EnvironmentBanner;
}(_react.Component), _class.displayName = "EnvironmentBanner", _class.propTypes = {
  className: _propTypes2.default.string,
  env: _propTypes2.default.oneOf(["development", "staging", "production"])
}, _class.defaultProps = {
  env: process.env.NODE_ENV
}, _temp2);
exports.default = EnvironmentBanner;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/EnvironmentBanner.js
 ** module id = 782
 ** module chunks = 0
 **/